const STORAGE_KEY = 'mindmixer_anonymous_id';

export const getOrCreateSessionId = (): string => {
  const existingId = localStorage.getItem(STORAGE_KEY);
  if (existingId) {
    return existingId;
  }

  const newId = crypto.randomUUID();
  localStorage.setItem(STORAGE_KEY, newId);
  return newId;
};
